import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgOtpInputComponent } from 'ng-otp-input';
import { Subscription } from 'rxjs/internal/Subscription';
import { OTPConfig } from 'src/app/Models/otpConfig';
import { LoadingService } from 'src/app/Service/loading.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { DashBoardService } from 'src/app/User/Pages/dash-board/dash-board.service';

@Component({
    selector: 'app-secure-link-authentication',
    templateUrl: './secure-link-authentication.component.html',
    styleUrls: ['./../../Pages/landing/landing.component.css',
        './secure-link-authentication.component.css'],
    standalone: false
})
export class SecureLinkAuthenticationComponent implements OnInit {
  @ViewChild('pricing') pricing;
  subscriptions: Subscription = new Subscription();
  otp: any;
  @Input() id;
  isAccessGranted: boolean = false;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInputs: NgOtpInputComponent;
  otpForm: UntypedFormGroup;
  constructor(
    public dashBoardService: DashBoardService,
    private notification: NotificationService,
    public activeModal: NgbActiveModal,
    private loader: LoadingService,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
  ) {
    this.loader.HideLoading();
  }
  ngOnInit() {
    this.otpForm = this.formBuilder.group({
      passCode: [
        '',
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
      id: [this.id, Validators.required],
    });
  }
  public otpconfig: OTPConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '50px',
      height: '50px',
      padding:'0px',
    },
  };
  onOtpChange(passcode) {
    this.otpForm.controls['passCode'].setValue(passcode);
  }
  onClose() {
    this.activeModal.close(0);
  }
  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  onSubmit() {
    if (this.otpForm.valid) {
      if (!this.dashBoardService.IsSecureFileUpload) {
        this.subscriptions.add(this.dashBoardService
          .SecureFileAccess(this.otpForm.value)
          .subscribe((res) => {
            if (res.data) {
              this.isAccessGranted = true;
              setTimeout(() => {
                this.activeModal.close(res.data);
              }, 2500);
            } else {
              this.notification.showWarning('You entered an invalid security code. Please try again. ');
            }
          }));
      }
      else {
        this.subscriptions.add(this.dashBoardService
          .AccessCodeValidate(this.otpForm.value)
          .subscribe((res) => {
            if (res.data) {
              this.isAccessGranted = true;
              setTimeout(() => {
                this.dashBoardService.IsSecureFileUpload=false;
                this.activeModal.close(this.otpForm.value);
              }, 2500);
            } else {
              this.notification.showWarning('You entered an invalid security code. Please try again. ');
            }
          }));
      }
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
